<div class="mb-3">
  <label class="form-label fw-semibold text-label mb-2">
    Select where the user should be able to access the platform:
  </label>
  
  <div class="d-flex flex-column gap-2">
    <div class="form-check custom-radio">
      <input
        class="form-check-input"
        type="radio"
        name="platformAccess"
        id="accessWeb"
        [checked]="selectedAccess === 'WEB'"
        (change)="onSelectionChange('WEB')"
      />
      <label class="form-check-label text-body cursor-pointer" for="accessWeb">
        Web only
      </label>
    </div>

    <div class="form-check custom-radio">
      <input
        class="form-check-input"
        type="radio"
        name="platformAccess"
        id="accessMobile"
        [checked]="selectedAccess === 'MOBILE'"
        (change)="onSelectionChange('MOBILE')"
      />
      <label class="form-check-label text-body cursor-pointer" for="accessMobile">
        Mobile only
      </label>
    </div>

    <div class="form-check custom-radio">
      <input
        class="form-check-input"
        type="radio"
        name="platformAccess"
        id="accessBoth"
        [checked]="selectedAccess === 'BOTH'"
        (change)="onSelectionChange('BOTH')"
      />
      <label class="form-check-label text-body cursor-pointer" for="accessBoth">
        Web and mobile
      </label>
    </div>
  </div>
</div>
